import { render, staticRenderFns } from "./listaIngressos.vue?vue&type=template&id=dd906d36&scoped=true&"
import script from "./listaIngressos.vue?vue&type=script&lang=js&"
export * from "./listaIngressos.vue?vue&type=script&lang=js&"
import style0 from "./listaIngressos.vue?vue&type=style&index=0&id=dd906d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd906d36",
  null
  
)

export default component.exports